import axios from 'axios';
import { useMutation } from 'react-query';
import useStore from 'zstore';

const updatePartnerLibrary = ({ id, payload }) => {
  return axios.put(`/api/v3/partners/${id}/partner_library`, payload);
};

export const useMutatePartnerLibrary = () => {
  const { makeToast } = useStore();

  return useMutation(updatePartnerLibrary, {
    onError: (error: any) => {
      console.error(error);
      makeToast({
        text: 'Uh-oh! Something went wrong. Please try again.',
        isError: true,
      });
    },
  });
};
